<template>
  <div>
    <b-row>
      <b-col sm="5" class="form-label">
        <i class="fa fax fa-user-circle"></i>
        <label>Inschrijfnummer</label>
      </b-col>
      <b-col sm="6">
        <b-form-input
                size="sm"
                :disabled="true"
                v-model="person.registrationnumber"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="5" class="form-label">
        <i class="fad fax fa-tag"></i>
        <label>Voorletters</label>
      </b-col>
      <b-col sm="6">
        <b-form-input
                size="sm"
                :disabled="true"
                v-model="person.initials"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="5" class="form-label">
        <i class="fad fax fa-user-tag"></i>
        <label>Achternaam</label>
      </b-col>
      <b-col sm="6">
        <b-form-input
                size="sm"
                :disabled="true"
                v-model="person.lastname"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    person: {
      type: Object,
      default: {
        registrationnumber: '',
        lastname: '',
        initials: '',
      }
    },
  }
}
</script>